import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import PageShell from '../components/PageShell';
import ForgotPasswordCard from '../components/ForgotPasswordCard';

function StoreForgotPassword() {
    return (
        <PageShell
            title="Recuperar Contraseña de Tienda"
            nav={<Button component={RouterLink} to="/" color="inherit" startIcon={<HomeIcon />}>Volver al Inicio</Button>}
            maxWidth="sm"
        >
            <ForgotPasswordCard apiBase="/store" loginPath="/store/login" />
        </PageShell>
    );
}

export default StoreForgotPassword;
